import { Divider, Stack } from '@mui/material';
import LuggageIcon from '@mui/icons-material/Luggage';
import NoLuggageIcon from '@mui/icons-material/NoLuggage';
import BackpackIcon from '@mui/icons-material/Backpack';
import { AccordionSection } from './AccordionSection';
import { ToggleSwitch } from './ToggleSwitch';
import { useFlightsFilters } from 'legacyfrontend/contexts/FlightsFiltersContext';
import { useEffect, useState } from 'react';

export const BaggageFilter = ({ dropdownState, toggleDropdown, background }) => {
  const { filters, handleFilters } = useFlightsFilters();
  const [withBaggage, setWithBaggage] = useState(filters.baggageFilters?.withBaggage || false);
  const [withoutBaggage, setWithoutBaggage] = useState(
    filters.baggageFilters?.withoutBaggage || false
  );

  const handleAllBaggageChange = () => {
    handleFilters('baggageFilters', {
      withBaggage: false,
      withoutBaggage: false,
    });
    setWithBaggage(false);
    setWithoutBaggage(false);
  };

  const handleWithBaggageToggle = () => {
    const newWithBaggageValue = !withBaggage;
    handleFilters('baggageFilters', {
      withBaggage: newWithBaggageValue,
      withoutBaggage: false,
    });
    setWithBaggage(newWithBaggageValue);
    setWithoutBaggage(false);
  };

  const handleWithoutBaggageToggle = () => {
    const newWithoutBaggageValue = !withoutBaggage;
    handleFilters('baggageFilters', {
      withBaggage: false,
      withoutBaggage: newWithoutBaggageValue,
    });
    setWithBaggage(false);
    setWithoutBaggage(newWithoutBaggageValue);
  };

  useEffect(() => {
    setWithBaggage(filters.baggageFilters?.withBaggage || false);
    setWithoutBaggage(filters.baggageFilters?.withoutBaggage || false);
  }, [filters.baggageFilters]);

  return (
    <Stack gap={2}>
      <AccordionSection
        isOpen={dropdownState.luggage}
        onToggle={() => toggleDropdown('luggage')}
        title='Equipaje'
      >
        <Stack spacing={2}>
          <ToggleSwitch
            background={background}
            icon={BackpackIcon}
            isActive={!withBaggage && !withoutBaggage}
            label='Todas'
            onChange={handleAllBaggageChange}
          />
          <ToggleSwitch
            background={background}
            icon={LuggageIcon}
            isActive={withBaggage}
            label='Solo Bodega'
            onChange={handleWithBaggageToggle}
          />
          <ToggleSwitch
            background={background}
            icon={NoLuggageIcon}
            isActive={withoutBaggage}
            label='Sin Equipaje'
            onChange={handleWithoutBaggageToggle}
          />
        </Stack>
      </AccordionSection>
      <Divider />
    </Stack>
  );
};
